import { render } from "./GameBoard.vue?vue&type=template&id=94ce3996"
import script from "./GameBoard.vue?vue&type=script&lang=js"
export * from "./GameBoard.vue?vue&type=script&lang=js"

import "./GameBoard.vue?vue&type=style&index=0&id=94ce3996&lang=css"
script.render = render

export default script